<tooltip-content #arrowTooltip>    
    <b>Mostra a conversão entre o passo anterior e atual.</b>
    <br>
    <span>Em laranja, a conversão do tráfego sem interagir com o Polen.</span>
    <br>
    <span>Em roxo, a conversão do tráfego que interagiu com o Polen.</span>
</tooltip-content>

<div class="slot-bar" >
    <div class="default-arrow" *ngIf="arrow.active == false">
        <div id="pointer"></div>
    </div>
    <div class="default-arrow" *ngIf="arrow.active && type != 'allsite'">
        <div *ngFor="let section of arrow.arrows" [tooltip]="arrowTooltip" id="pointer" [ngClass]="{'pointer-polen': section.type == 0,'pointer-original': section.type == 1}">
            <span>{{section.value | number:'.1-1'}}%</span>
        </div>
    </div>
</div>

<!-- <div class="slot-bar" *ngIf="arrow.active == false">
        <div class="default-arrow">
            <div id="pointer"></div>
        </div>
    </div>
    
    <div class="slot-bar" *ngIf="arrow.active && type != 'allsite'">
        <div class="default-arrow">
            <div *ngFor="let section of arrow.arrows" id="pointer" [ngClass]="{'pointer-polen': section.type == 0,'pointer-original': section.type == 1}">
                <span>{{section.value | number:'2.1-1'}}%</span>
            </div>
            
        </div>
    </div> -->